import React, { useState } from 'react';
import { Form, Input, Button, message } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import request from '../utils/request';
import AuthService from '../utils/auth';
import '../styles/login.css';

const Login = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onFinish = async values => {
    setLoading(true);
    try {
      console.log('🚀 开始登录:', values.username);
      
      const response = await request.post('/admin/auth/login', {
        username: values.username,
        password: values.password
      });
      
      if (response && response.success) {
        // 保存认证信息
        AuthService.saveAuth(response.data);
        
        message.success('登录成功');
        
        // 跳转到首页
        setTimeout(() => {
          navigate('/', { replace: true });
        }, 100);
      } else {
        message.error(response?.message || '登录失败');
      }
    } catch (error) {
      // 取消的重复请求静默处理，不显示错误
      if (axios.isCancel(error)) {
        return;
      }
      
      console.error('❌ 登录失败:', error);
      
      let errorMessage = '登录失败';
      if (error.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        errorMessage = error.message;
      }
      
      message.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-brand-panel">
        <div className="login-brand-mark">洁</div>
        <div className="login-brand-eyebrow">XINJIE TEA COMMERCE</div>
        <h1>让每一次经营决策<br />都有数据依据</h1>
        <p>统一管理商品、订单、售后、会员与商城运营。</p>
        <div className="login-brand-meta">
          <span>商品运营</span><span>交易履约</span><span>客户管理</span>
        </div>
      </div>
      <div className="login-container">
        {/* 登录卡片 */}
        <div className="login-card">
          {/* LOGO区域 */}
          <div className="login-logo">
            <div className="logo-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M9 12l2 2 4-4"></path>
                <circle cx="12" cy="12" r="9"></circle>
              </svg>
            </div>
          </div>

          {/* 标题 */}
          <div className="login-title">心洁茗茶管理系统</div>
          <div className="login-subtitle">欢迎回来，请登录您的管理账户</div>
          
          {/* 登录表单 */}
          <Form
            name="login"
            onFinish={onFinish}
            autoComplete="off"
            layout="vertical"
          >
            <Form.Item
              name="username"
              rules={[{ required: true, message: '请输入用户名!' }]}
            >
              <Input
                prefix={<UserOutlined />}
                placeholder="请输入用户名"
                size="large"
                autoComplete="username"
              />
            </Form.Item>
            
            <Form.Item
              name="password"
              rules={[{ required: true, message: '请输入密码!' }]}
            >
              <Input.Password
                prefix={<LockOutlined />}
                placeholder="请输入密码"
                size="large"
                autoComplete="current-password"
              />
            </Form.Item>

            <div className="login-security-note">仅限授权管理员访问</div>
            
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                className="login-button"
                loading={loading}
                size="large"
                block
              >
                立即登录
              </Button>
            </Form.Item>
          </Form>

          {/* 底部信息 */}
          <div className="login-footer">
            <div className="copyright">© 2024 心洁茗茶. All rights reserved.</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;